<template>
  <div class="contact-page">
    <div class="header-wrap app-flex-mid-center">
      <img src="../../../assets/contact.png" class="bg" />
    </div>
    <base-foot :type="2"></base-foot>
  </div>
</template>

<script>
import BaseFoot from '../components/BaseFoot.vue'

export default {
  name: 'ContactPage',
  components: {
    BaseFoot
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  width: 100%;
  .header-wrap {
    width: inherit;
    height: 676px;
    overflow: hidden;
    .bg {
      height: 676px;
      width: auto;
    }
  }
}
</style>
